let baseUrl = ''
let url = window.location.hostname
if (url === 'pianchang.aiyaopai.com') {
  baseUrl = 'https://liveclientapiv2.aiyaopai.com'
} else {
  baseUrl = 'https://liveclientapiv2.dev.aiyaopai.com'
}
// if (process.env.NODE_ENV == 'development') {
//   baseUrl = 'https://liveclientapiv2.dev.aiyaopai.com'
// } else if (process.env.NODE_ENV == 'production') {
//   baseUrl = 'https://liveclientapiv2.aiyaopai.com'
// }
export default baseUrl
